export default __webpack_public_path__ + "static/media/load.45775b0b.svg";